import { render } from "./InstallerButton.vue?vue&type=template&id=6b311b44&scoped=true"
import script from "./InstallerButton.vue?vue&type=script&lang=js"
export * from "./InstallerButton.vue?vue&type=script&lang=js"

import "./InstallerButton.vue?vue&type=style&index=0&id=6b311b44&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b311b44"]])

export default __exports__